import { GetStaticProps } from 'next/types';
import Component from 'components/pages/SurveyTips/SurveyTips';
import { buildPage } from 'utils/pageHelper';
import SURVEY_TIPS from 'constants/surveyTips';

export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Qmee Survey Tips',
    description: "Become a 'Survey Winner' when earning money with Qmee!",
    imageUrl: 'https://cdn.assets.qmee.com/colour-scheme/survey-tips/banners/SocialShareBanner.png',
  },
});

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      surveyTips: SURVEY_TIPS,
    },
  };
};
